import { PaginateQuery } from "core/resources/types/shared";

export interface ProcuracaoItem {
  id: string;
  totalPeso: number;
  solicitante: {
    id: string;
    nome: string;
  };
  representante: {
    id: string;
    nome: string;
  };
  status: {
    id: StatusProcuracaoEnum;
    nome: string;
  };
}

export interface ProcuracaoDetalheUnidade {
  id: string;
  numero: string;
  blocoQuadra: string | null;
  peso: number;
}

export interface ProcuracaoDetalheLog {
  status: { id: StatusProcuracaoEnum; nome: string };
  observacao: string;
  pessoa: {
    id: string;
    nome: string;
  };
  createdAt: string;
  usuarioId: string;
}
export interface ProcuracaoDetalhePessoa {
  id: string;
  nome: string;
  email: string;
  documento: string;
  celular: string;
  imagemUrl: string | null;
}
export interface ProcuracaoDetalhe {
  id: string;
  nomeVotacao: string;
  totalPeso: number;
  assinaturaArquivo: {
    id: string;
    referencia: string;
  };
  assinaturaDigital: boolean;
  pessoaExterna: boolean;
  unidades: ProcuracaoDetalheUnidade[];
  solicitante: ProcuracaoDetalhePessoa;
  representante: ProcuracaoDetalhePessoa;
  status: {
    id: StatusProcuracaoEnum;
    nome: string;
  };
  logs: ProcuracaoDetalheLog[];
}

export enum StatusProcuracaoEnum {
  Pendente = "DBB67288-A6E9-40CD-983E-0F08F594D42A",
  Aprovada = "89FFE8A8-021B-4EC9-873D-442CF13DE0CC",
  EmAnalise = "29539778-1AC6-4D40-A21A-5F36DD70C723",
  Rejeitada = "C8C70D75-C479-4DC6-B32A-93038292B175",
  Cancelada = "C8C70D75-C479-4DC6-B32A-93038292B172",
}

export interface ProcuracaoListagemQuery extends PaginateQuery {
  idAssembleia: string;
  status?: StatusProcuracaoEnum;
}
